import React from 'react';

const AlertIcon = () => {
  return (
    <svg
      width="1156"
      height="338"
      viewBox="0 0 1156 338"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M740.171 220.77C753.14 219.592 763.312 208.452 763.304 195.232C763.302 181.78 753.095 170.871 739.896 169.72C737.562 146.277 717.871 127.964 693.81 127.986C672.973 127.993 655.39 141.945 649.61 160.979C635.261 163.301 624.381 175.624 624.4 190.703C624.421 206.479 636.692 219.705 652.208 220.837L740.171 220.77Z"
        stroke="#404040"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M453.355 240C460.357 239.36 465.855 233.241 465.855 225.971C465.855 218.572 460.357 212.581 453.229 211.941C451.975 199.064 441.356 189 428.355 189C417.109 189 407.619 196.654 404.483 207.102C396.728 208.381 390.855 215.14 390.855 223.412C390.855 232.09 397.481 239.339 405.842 239.979H453.355V240Z"
        stroke="#404040"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M535.855 52.9805C527.26 40.3035 512.86 32 496.503 32C475.007 32 456.86 46.5575 450.888 66.4392C436.071 68.8689 424.855 81.7148 424.855 97.4765C424.855 113.957 437.507 127.796 453.51 129H482.082"
        stroke="#404040"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M613.834 272.061L653.85 271.942L653.713 236.068"
        stroke="#404040"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M652.425 132.085L652.351 106.447L612.967 67.9719L494.002 68.3704L494.628 273.014L542.318 272.87"
        stroke="#404040"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M652.051 108L611.049 107.626L611.436 68.1988"
        stroke="#404040"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M623.196 290.715L578.103 335.137L533.16 290.451L558.315 290.538L558.629 199.591L596.582 199.705L596.267 290.632L623.196 290.715Z"
        stroke="#404040"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AlertIcon;
